import React from 'react';
import { Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  addressFields: {
    paddingTop: '15px',
  },
}));

const AddressFields = ({
  address,
  handleChangeField,
  addressErrors,
  variant = 'standard',
}) => {
  const classes = useStyles();
  return (
    <>
      {address && (
        <Box>
          <Grid container spacing={1} className={classes.addressFields}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Address Line 1"
                id="address_line_1"
                value={address.address_line_1}
                onChange={handleChangeField}
                required
                error={addressErrors.includes('address_line_1')}
                helperText={
                  addressErrors.includes('address_line_1') ? 'Required' : null
                }
                variant={variant}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Address Line 2"
                id="address_line_2"
                value={address.address_line_2 || ''}
                onChange={handleChangeField}
                variant={variant}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="City"
                id="city"
                value={address.city}
                onChange={handleChangeField}
                required
                error={addressErrors.includes('city')}
                helperText={addressErrors.includes('city') ? 'Required' : null}
                variant={variant}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="State"
                id="state"
                value={address.state}
                onChange={handleChangeField}
                required
                error={addressErrors.includes('state')}
                helperText={addressErrors.includes('state') ? 'Required' : null}
                variant={variant}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="ZIP/Postal Code"
                id="postal_code"
                value={address.postal_code}
                onChange={handleChangeField}
                required
                error={addressErrors.includes('postal_code')}
                helperText={
                  addressErrors.includes('postal_code') ? 'Required' : null
                }
                variant={variant}
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default AddressFields;
